import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap, catchError, throwError, finalize } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  private readonly apiUrl = environment.apiUrl;
  private readonly _isConnected$ = new BehaviorSubject<boolean>(true);
  private _isRetrying = false;

  public readonly isConnected$ = this._isConnected$.asObservable();

  public get isRetrying(): boolean {
    return this._isRetrying;
  }

  public constructor(private readonly http: HttpClient) {}

  public setDisconnected(): void {
    this._isConnected$.next(false);
  }

  public setConnected(): void {
    this._isConnected$.next(true);
  }

  public checkConnection(): Observable<unknown> {
    this._isRetrying = true;

    return this.http.get(`${this.apiUrl}/health`).pipe(
      tap(() => {
        this.setConnected();
      }),
      catchError((error) => {
        return throwError(() => error);
      }),
      finalize(() => {
        this._isRetrying = false;
      })
    );
  }
}


